<div class="popup-wrap2"
     (click)="onVoid($event)">

  <article class="popup-connect-box">

    <app-link-popup-item-word *ngFor="let word of listWord; let idx = index"
                              [word]="word"
                              [showMoreBtn]="!isSingleLink"
                              (afterViewInit)="onItemAfterViewInit()"
                              (close)="onCloseWord($event)">
    </app-link-popup-item-word>

    <app-link-popup-item-dialect *ngFor="let dialect of listDialect; let idx = index"
                                 [dialect]="dialect"
                                 [showMoreBtn]="!isSingleLink"
                                 (afterViewInit)="onItemAfterViewInit()"
                                 (close)="onCloseDialect($event)">
    </app-link-popup-item-dialect>

    <div *ngIf="IsLoading"
         class="connect-body">
      <div class="reload-icon">
        <img src="assets/img/loading_icon.gif">
      </div>
    </div>

    <!-- div class="connect-body"
         *ngIf="getMoreTxt()" -->
    <div class="connect-tail">
      <div class="more-link-btn-box">
        <a class="more-link-btn"
           (click)="onCloseMore($event)">{{ !isSingleLink ? '전체 보기' : '자세히 보기' }}</a>
        <div *ngIf="getMoreTxt()"
             class="more-txt">{{ getMoreTxt() }}</div>
      </div>

      <div class="menu-box">
        <a class="close-btn"
           (click)="onClose($event)"></a>
      </div>

      <!-- div *ngIf="getMoreTxt()"
           class="tooltip-item">
        <div class="tooltip-link-box">
          <a class="tooltip-link-btn"
             (click)="onCloseMore($event)">
            <span class="txt more">{{ getMoreTxt() }}</span>
            <span class="txt">전체 보기</span>
            <i class="ic ic-link"></i>
          </a>
        </div>
      </div -->

    </div>

  </article>
</div>
